import axios from '@/plugins/axios'
import { disableInterceptor } from '@/utils/HeaderNoInterceptors'


export default function useSitio() {

  const getDestacados = async () => {
    const { data } = await axios.get('fidelizacion/destacados',
      disableInterceptor)
    return data
  }

  const getExperiencias = async () => {
    const { data } = await axios.get('fidelizacion/experiencias',
      disableInterceptor)
    return data
  }

  const getNovedades = async () => {
    const { data } = await axios.get('fidelizacion/novedades',
      disableInterceptor)
    return data
  }

  const getBeneficios = async () => {
    const { data } = await axios.get('fidelizacion/beneficios',
      disableInterceptor)
    return data
  }

  const getMisBeneficios = async () => {
    const { data } = await axios.get('fidelizacion/mis-beneficios',
      disableInterceptor)
    return data
  }


  return {
    getDestacados,
    getExperiencias,
    getNovedades,
    getBeneficios,
    getMisBeneficios
  }
}
